import React, { useCallback } from 'react'
import Users from '../../../BoardHeader/Users/Users'
import { Grid } from '@mui/material';

const Collaborators = ({ ownerId, boardId, cardId, boardName, cardCollabrator, assigneeUserId, canAddCollaborator = false, updateCardmutate }) => {

  const handleAddColabrotor = useCallback( (userId) => {
    updateCardmutate({
      card_id: cardId,
      data: {
        collaborator_user_id: userId,
      },
    });
  },[updateCardmutate, cardId]);

    const handleRemoveColabrotor = useCallback( (userId) => {
      updateCardmutate({
        card_id: cardId,
        data: {
          remove_collaborator_user_id: userId,
        },
      });
    },[updateCardmutate, cardId]);

  return (
    <div className="box">
    <Grid item className="allocated-hours ">
      <p>Collaborators</p>
      <div className="taskdetail-sidebar-right-col">
    <Users assigneeUserId={assigneeUserId} colabratorBoardName={boardName} boardId={boardId} ownerId={ownerId} isColabrotar={true} cardCollabrator={cardCollabrator} handleRemoveColabrotor={handleRemoveColabrotor} handleAddColabrotor={handleAddColabrotor} canAddCollaborator={canAddCollaborator} />
    </div>
    </Grid>
    </div> 
  )
}

export default React.memo(Collaborators)